import { render } from "./SingleText.vue?vue&type=template&id=0f53937a&lang=pug"
import script from "./SingleText.vue?vue&type=script&lang=js"
export * from "./SingleText.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__